import { Typography } from "@mui/material";
import React, { useState } from "react";
import AppButton from "component/button/AppButton";
import SecondaryAuthLayout from "component/secondaryAuthLayout/SecondaryAuthLayout";
import TextField from "component/textField/TextField";
import styles from "./ForgotPassword.module.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForgotPassword } from "api/mutations/auth/ForgotPassword";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import { useNavigate } from "react-router-dom";
import { forgotPasswordSchema } from "schemas/auth/AuthSchemas";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });
  const {
    submit,
    loading,
    setOpenModal,
    openModal,
    severity,
    openToast,
    setOpenToast,
    message,
    duration,
  } = useForgotPassword();

  const submitEmail = (data) => {
    setEmail(data?.email);
    submit(data);
  };

  const handleGoToreset = () => {
    navigate("/reset-code", {
      state: {
        email: email,
      },
    });
  };

  return (
    <SecondaryAuthLayout>
      <div className={styles.forgot_password}>
        <div className={styles.heading}>
          <Typography variant="h1">Forgot Password</Typography>
          <Typography>
            Input your email address, and we'll give you information on how to
            change your password.
          </Typography>
          <Typography>
            We don’t store passwords for security reasons. So you can be
            confident that we will never email your password.
          </Typography>
        </div>
        <form onSubmit={handleSubmit(submitEmail)} className={styles.form}>
          <div className={styles.field}>
            <TextField
              errors={errors}
              name="email"
              register={register}
              required={true}
              type="text"
              label="Email"
              placeholder="Examplejoe@gmail.com"
            />
          </div>

          <div className={styles.form_btn}>
            <AppButton
              loading={loading}
              fullwidth
              textColor="#FFFFFF"
              btnBg="#0089FF"
              btnText="Submit"
            />
          </div>
        </form>
      </div>
      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              handleGoToreset();
            }}
            icon={"info"}
            secondaryText="Check your mailbox, a verification PIN was sent in, copy the code and
          input to continue with your recovery."
          />
        }
      />
      <TTFSnackbar
        severity={severity}
        message={message}
        open={openToast}
        setOpen={setOpenToast}
        duration={duration}
      />
    </SecondaryAuthLayout>
  );
}

export default ForgotPassword;
